<fm-pendo *ngIf="pendoEnabled" [isAnonymousVisitor]="true"></fm-pendo>

<title title="Verizon Connect | GPS Fleet Tracking System" i18n-title="@@S_ACCOUNT_ACTIVATION_VERIZON_CONNECT_TITLE"></title>

<app-reveal-header></app-reveal-header>

<div class="vzc-content-container">
  <router-outlet></router-outlet>
</div>
